import React from 'react';
import Loader from '../loader/loader.component';
import styles from './processing.module.css';

export function Processing({ isLoading, label = 'Processando...' }: { isLoading: boolean, label?: string }) {
    if (!isLoading) return null;

    return <div className={styles.overlay}>
        <div className={styles.card}>
            <Loader label={label} size='large' />
        </div>
    </div>
}
